import React from 'react';
import { Divider, Row, Col } from 'antd';

import { getFullName } from 'utils/personUtils';
import { ContactPersonModel } from 'api/backofficeApiClient';
import { AssignmentContactPersonViewModel } from 'api/adminApiClient';

type Props = {
  contact: ContactPersonModel | AssignmentContactPersonViewModel;
  index: number;
};

export default function PrimaryContactInfoSection(props: Props) {
  const { contact, index } = props;
  const contactName = getFullName(contact?.firstName, contact?.lastName);

  return (
    <div className="divider-box sub-content">
      <div className="content-wrapper">
        <Row>
          {!!contactName && (
            <Col xs={24} md={12} data-id={`primaryContactName-${index}`}>
              <div className="title">Primary contact: </div>
              <div>{contactName}</div>
            </Col>
          )}

          {contact?.title && (
            <Col xs={24} md={12} data-id={`primaryContactTitle-${index}`}>
              <div className="title">Title: </div>
              <div>{contact.title}</div>
            </Col>
          )}

          {contact?.email && (
            <Col xs={24} md={12} data-id={`primaryContactEmail-${index}`}>
              <div className="title">Email: </div>
              <div>{contact.email}</div>
            </Col>
          )}

          {contact?.phoneNumber && (
            <Col
              xs={24}
              md={12}
              data-id={`primaryContactPhoneNumber--${index}`}
            >
              <div className="title">Phone number: </div>
              <div>{contact?.phoneNumber}</div>
            </Col>
          )}
        </Row>
      </div>
      <Divider className="card-divider no-margin" />
    </div>
  );
}
